import { render } from "./BaseHeader.vue?vue&type=template&id=61e1c620&scoped=true&ts=true"
import script from "./BaseHeader.vue?vue&type=script&lang=ts"
export * from "./BaseHeader.vue?vue&type=script&lang=ts"

import "./BaseHeader.vue?vue&type=style&index=0&id=61e1c620&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e1c620"]])

export default __exports__